import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateUsersSiteRoleParams {
  userIds: string[];
  siteRole: string;
}

export interface IUpdateUsersSiteRoleResult extends IResult {
}

export class UpdateUsersSiteRoleRequest extends Request<IUpdateUsersSiteRoleParams, IUpdateUsersSiteRoleResult> {
  constructor(params: IUpdateUsersSiteRoleParams) {
    super('updateUsersSiteRole', params);
  }
}
